<script setup>
import {onBeforeMount, reactive, ref, nextTick} from "vue";
import createTenantClub from "./components/createTenantClub/index.vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import BoxUpload from "@/components/YTBoxUpload/newIndex.vue";
import {
  api_albumCollectList,
  api_albumShowList, api_cancelAlbumShow,
  api_cancelCollectActivityPhoto,
  api_setAlbumShow,
  api_uploadAlbumShow
} from "@/api/club/club.js";
import { userInfoStore } from "@/store/store.js";
import YTCard from "@/components/YTCard/newIndex.vue";
import creatTenantClubPersonal from "./components/creatTenantClubPersonal/index.vue";
import router from "@/router/index.js";
import {getClubIgnore, updateClubIgnore, updateClubPersonnelInfoIgnore} from "@/api/club/ignoreTenant.js";
import {getRoute} from "@/hooks/getRoute.js";
import YTDialog from "@/components/YTDialog/index.vue";
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 用户信息
const userInfo = ref(userInfoStore().info);

// 带参则为修改
const isEdit = ref(false)
// 当前storeId
const currentStoreId = ref()
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.storeId)
  if (isEdit.value) {
    currentStoreId.value = route.query.storeId
    await getDetail()
    await getAlbumCollectList();
  } else {
    ElMessage.error("信息获取失败")
    loading.value = true
  }
})

/*标签页相关*/
// 当前标签页
const currentTab = ref("1")
// 处理标签页改变
const handleTabChange = async (e) => {
  console.log("run in handleTabChange", e)
  if (currentTab.value === "3") {
    await getAlbumCollectList()
    await getAlbumShowList()
  }
}

// 加载状态
const loading = ref(false)
// 处理表单提交新建俱乐部
const handleCreateTenantClub = async (form) => {
  try {
    loading.value = true
    await updateClubIgnore(ruleForm.value)
    ElMessage.success("修改成功")
    router.push("/listTenantClub")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理表单提交添加俱乐部主理人信息
const handleCreateTenantClubPersonnelInfo = async () => {
  try {
    loading.value = true
    await updateClubPersonnelInfoIgnore(ruleForm.value.storeId, ruleFormPersonal)
    ElMessage.success("修改成功")
    router.push("/listTenantClub")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: null,
  tenantId: null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
  },
  contactName: null,
  phone: null,
  referralOfficer: {
    name: null,
    phone: null
  },
  certificationType: null,
  partnerStores: [],
  summary: null,
  summaryEn: null,
  description: null,
  descriptionEn: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  assistsOperation: false
})
// 创建商家俱乐部组件锚点
const createTenantClubRef = ref()
// 添加俱乐部主理人组件锚点
const creatTenantClubPersonalRef = ref()
// 获取商家信息
const getDetail = async () => {
  try {
    loading.value = true
    const res = await getClubIgnore(route.query.storeId)
    console.log("res", res)
    ruleForm.value = res
    let temp = [ruleForm.value.storeAddress.provinceCode, ruleForm.value.storeAddress.cityCode]
    if (ruleForm.value.storeAddress.districtCode) temp.push(ruleForm.value.storeAddress.districtCode)
    createTenantClubRef.value.handleReviewAddressCode(temp)
    let tempRecipient = [ruleForm.value.recipientInfo.recipientAddress.provinceCode, ruleForm.value.recipientInfo.recipientAddress.cityCode]
    if (ruleForm.value.recipientInfo.recipientAddress.districtCode) tempRecipient.push(ruleForm.value.recipientInfo.recipientAddress.districtCode)
    createTenantClubRef.value.handleReviewRecipientAddressCode(tempRecipient)
    createTenantClubRef.value.handleReviewPic([ruleForm.value.storeLogo])
    ruleFormPersonal.personnelInfo = res.personnelInfo
    // 多个上传组件渲染，导致第二第三个主理人头像无法出发反显函数，使用nextTick
    nextTick(() => {
      creatTenantClubPersonalRef.value.handleReviewPersonnelInfoUploadPic(res.personnelInfo)
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*主理人信息相关*/
// 主理人信息表单信息
const ruleFormPersonal = reactive({
  personnelInfo: [
    {
      avatar: null,
      name: null,
      nameEn: "Coming Soon ...",
      summaryInfo: [
        {
          summary: null,
          summaryEn: "Coming Soon ..."
        }
      ]
    }
  ]
})

/*相册相关*/
const album_loading = ref(false);
const album_list = reactive([]);
const album_page_params = reactive({
  pageNum: 1,
  pageSize: 20,
});
const album_show_list = reactive([]);
const album_total = ref(0);
const albumPaginationRef = ref();
// 显示图片预览
const showPreview = (item) => {
  dialogImageUrl.value = item.albumImage;
  dialogVisible.value = true;
};
const showCCDialog = async (id) => {
  cancel_albumImageId.value = id;
  cancel_collect_show.value = true;
};
// 删除主页相册照片
const deleteAlbumShowImage = async (id) => {
  try {
    album_loading.value = true;
    await api_cancelAlbumShow({
      albumImageId: id,
      storeId: currentStoreId.value,
    });
    await getAlbumShowList();
    await getAlbumCollectList();
    album_loading.value = false;
    ElMessage.success("已取消主页展示");
  } catch (error) {
    console.log(error);
    album_loading.value = false;
    ElMessage.error("取消主页展示失败");
  }
};
// 取消收藏相册照片
const cancelCollectAlbum = async () => {
  try {
    cancel_collect_show.value = false;
    album_loading.value = true;
    await api_cancelCollectActivityPhoto({
      albumImageId: cancel_albumImageId.value,
      storeId: currentStoreId.value,
    });
    await getAlbumCollectList();
    await getAlbumShowList();
    album_loading.value = false;
    ElMessage.success("已取消收藏");
  } catch (error) {
    console.log(error);
    cancel_collect_show.value = false;
    album_loading.value = false;
    ElMessage.error("取消收藏失败");
  }
};
const useAlbum = async (item) => {
  if (item.isHomepageDisplay) {
    return;
  }
  try {
    album_loading.value = true;
    await api_setAlbumShow({
      storeId: currentStoreId.value,
      albumImageId: item.albumImageId,
    });
    await getAlbumCollectList();
    await getAlbumShowList();
    album_loading.value = false;
    ElMessage.success("已使用");
  } catch (error) {
    console.log(error);
    ElMessage.error("使用失败");
    album_loading.value = false;
  }
};
// 相册收藏列表分页事件处理
const handleAlbumPageChange = () => {
  album_page_params.pageNum = albumPaginationRef.value.getPage();
  album_page_params.pageSize = albumPaginationRef.value.getPageSize();
  getAlbumCollectList();
};
// 上传失败
const handlePicFail = () => {
  album_loading.value = false;
};
// 上传中
const handlePicProgress = () => {
  album_loading.value = true;
};
// 上传成功
const handleAlbumSuccess = async (photo_arr) => {
  try {
    const album_list = [...photo_arr];
    console.log("album_list: ", album_list);
    await Promise.all(
        album_list.map((item) =>
            api_uploadAlbumShow({
              storeId: currentStoreId.value,
              albumImage: item[0],
            })
        )
    );
    await getAlbumShowList();
  } catch (err) {
    console.log(err);
    album_loading.value = false;
  }
};
const getAlbumCollectList = async () => {
  try {
    album_loading.value = true;
    const res = await api_albumCollectList(
        album_page_params,
        currentStoreId.value
    );
    album_list.length = 0; // 清空数组
    album_list.push(...res.list); // 添加新元素
    album_total.value = res.total || 0; // 设置总数
    album_loading.value = false;
  } catch (error) {
    console.log(error);
    album_loading.value = false;
  }
};
const getAlbumShowList = async () => {
  try {
    album_loading.value = true;
    const res = await api_albumShowList({
      storeId: currentStoreId.value,
    });
    Object.assign(album_show_list, res);
    console.log("album_show_list==========================", album_show_list)
    album_show_list.length = 0;
    album_show_list.push(...res);
    album_loading.value = false;
  } catch (error) {
    console.log(error);
    album_loading.value = false;
  }
};

/*图片预览相关*/
const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const cancel_collect_show = ref(false);
const cancel_albumImageId = ref(0);
</script>

<template>
  <el-tabs
      v-model="currentTab"
      type="card"
      class="demo-tabs"
      @tab-change="handleTabChange"
  >
    <el-tab-pane label="基本信息" name="1">
    </el-tab-pane>
    <el-tab-pane label="主理人信息" name="2">
    </el-tab-pane>
    <el-tab-pane label="相册管理" name="3">
    </el-tab-pane>
  </el-tabs>
  <div v-loading="loading" v-show="currentTab === '1'" style="height: calc(100% - 55px)">
    <createTenantClub ref="createTenantClubRef" :is-edit="isEdit" v-model="ruleForm" @success="handleCreateTenantClub"></createTenantClub>
  </div>
  <div v-show="currentTab === '2'" style="height: calc(100% - 55px)">
    <creatTenantClubPersonal ref="creatTenantClubPersonalRef" @success="handleCreateTenantClubPersonnelInfo" v-model="ruleFormPersonal"></creatTenantClubPersonal>
  </div>
  <div v-loading="album_loading" v-show="currentTab === '3'" style="height: calc(100% - 55px)">
    <YTCard :title="`相册管理`" class="album_manage">
      <template #container>
        <div>
          <div class="collect">
            <div class="collect_title fwb">您的收藏</div>
            <div class="collect_list mt20">
              <div
                  class="collect_item ml20 mb20"
                  v-for="(item, index) in album_list"
                  :key="index"
                  @click="showPreview(item)"
              >
                <div class="collect_item_inner">
                  <img class="image" :src="item.albumImage" alt="" />
                  <img
                      class="collected"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/collected.svg"
                      alt=""
                      @click.stop="showCCDialog(item.albumImageId)"
                  />
                </div>

                <div
                    :class="[
                        'use',
                        'mt10',
                        item.isHomepageDisplay ? 'is_used' : '',
                      ]"
                    @click.stop="useAlbum(item)"
                >
                  {{ item.isHomepageDisplay ? "已使用" : "使用" }}
                </div>
              </div>
            </div>
            <!-- 分页组件 -->
            <YTTablePagination
                v-if="album_total > 0"
                ref="albumPaginationRef"
                :pageSize="album_page_params.pageSize"
                :total="album_total"
                @page-change="handleAlbumPageChange"
            />
          </div>
          <div class="home_show">
            <div class="home_show_title fwb">主页展示</div>
            <div class="home_show_list mt20">
              <div class="img_upload_info">
                <BoxUpload
                    :limit="50"
                    :fileSize="3"
                    :ali-oss-path="'HOMEPAGE'"
                    :baseUrl="'/upload/uploadImgs'"
                    :isReplaceMode="false"
                    :showFileList="false"
                    :cache_type="false"
                    @success="handleAlbumSuccess"
                    @progress="handlePicProgress"
                    @fail="handlePicFail"
                ></BoxUpload>
              </div>
              <div class="show_list ml20">
                <div
                    class="show_item ml20 mb20"
                    v-for="(item, index) in album_show_list"
                    :key="index"
                    @click="showPreview(item)"
                >
                  <img class="image" :src="item.albumImage" alt="" />
                  <img
                      class="del"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/img_del.svg"
                      alt=""
                      @click.stop="deleteAlbumShowImage(item.albumImageId)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </YTCard>
  </div>

  <!-- 图片预览对话框 -->
  <el-dialog v-model="dialogVisible" title="图片预览" width="50%">
    <div class="preview-container">
      <img
          :src="dialogImageUrl"
          alt="预览图片"
          style="width: 100%; height: auto"
      />
    </div>
  </el-dialog>

  <!-- 取消收藏二次确认弹窗 -->
  <YTDialog
      :open="cancel_collect_show"
      text="确认要取消收藏吗？"
      title="取消收藏"
      @confirm="cancelCollectAlbum"
      @cancel="cancel_collect_show = false"
  ></YTDialog>
</template>

<style lang="scss" scoped>
.album_manage {
  background: #fff;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  padding-right: 20px;

  .collect {
    .collect_title {
      text-align: left;
    }
    .collect_list {
      display: flex;
      flex-wrap: wrap;
      .collect_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .collect_item_inner {
          width: 100px;
          height: 100px;
          position: relative;
          .image {
            width: 100px;
            height: 100px;

            object-fit: cover;
            object-position: center;
            background: #f6f6f6;
            border-radius: 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }

          .collected {
            width: 33px;
            height: 26px;

            position: absolute;
            bottom: 1px;
            right: 1px;
          }
        }
        .use {
          text-align: center;
          background-color: #684fa2;
          padding: 5px 0px;
          width: 70%;
          border-radius: 20px;
          color: white;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
        }
        .is_used {
          background-color: #f6f6f6;
          color: black;
        }
      }
    }
  }
  .home_show {
    .home_show_title {
      text-align: left;
    }
    .home_show_list {
      display: flex;
      align-items: flex-start;
      text-align: left;
      .show_list {
        display: flex;
        flex-wrap: wrap;
        .show_item {
          position: relative;
          .image {
            width: 100px;
            height: 100px;

            object-fit: cover;
            object-position: center;
            background: #f6f6f6;
            border-radius: 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
          .del {
            width: 30px;
            height: 30px;

            position: absolute;
            top: -10px;
            right: -10px;
          }
        }
      }
    }
  }
}
</style>
